export default {
  title: 'Pay with PayPal',
  error: 'The PayPal payment could not be completed. Please try again.',
};
